import React, { useEffect, useMemo, useState } from "react";

import {
  Container,
  Form,
  WrapperForm,
  LeftSide,
  InputRow,
  ScheduleCard,
  Title,
  DateTag,
  Header,
  Description,
  InfoText,
  DateRow,
  DescriptionText,
  FormContent,
  Cards,
} from "./styles";
import { Button } from "../../../components/videoConference/Button";
import { Input } from "../../../components/videoConference/Input";
import { Modal } from "../../../components/videoConference/Modal";
import { ArrowRight } from "../../../components/videoConference/icons/ArrowRight";
import { getEventStyles, getWebinars } from "../api";
import { CustomField, StylesProps, WebinarsProps } from "../types";
import { getContrastColor } from "../../../utils/isDarkColor";
import { useParams, useHistory } from "react-router-dom";
import { isValidCpf, isValidDate, isValidEmail } from "../../../utils/helper";
import { TermsInput } from "../../../components/videoConference/AcceptTerms";
import { Select } from "../../../components/shared/InputSelect/style";
import { useTranslation } from "react-i18next";
import { subscribeApi } from "../../../api/SubscribeApi";

interface IStoragedUser {
  name: string;
  company: string;
  email: string;
  talk: string;
}

const monthsPortugese = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const monthsEnglish = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

interface RouteParams {
  kind: string;
}

export default function FormRegister({
  playback
}: {
  playback: string
}) {
  const history = useHistory()
  const [userData, setUserData] = useState<Map<string, string>>(new Map());
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState({ title: "", description: "" });
  const [talk, setTalk] = useState("");
  const [styles, setStyles] = useState<StylesProps | null>(null)
  const [webinars, setWebinars] = useState<WebinarsProps | null>(null)
  const [acceptTerms, setAcceptTerms] = useState(false);

  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  const languageCode = useMemo(() => {
    const code = i18n.language.split("-")[0].split("_")[0];
    if(code == "pt") {
      return "pt_br";
    }
    return code.toLowerCase();
  }, [i18n.language]);

  const isPt = currentLanguage === "pt" || currentLanguage === "pt-BR";

  const query = useParams<RouteParams>();

  useEffect(() => {
    getStyles()
    getGroup()
  }, [query.kind])

  useEffect(() => {
    if (webinars) {
      if (localStorage.getItem(`@NDI-WEBINAR-${webinars?.name}`)) {
        history.push(`/${query.kind}/assista`)
      }
      const params = new URLSearchParams(playback);

      const playbackValue = params.get('playback');

      if (!playbackValue) {
        setTalk(webinars?.talks[0]?.playback_stream_name)
      } else {
        setTalk(playbackValue)
      }
    }

  }, [webinars, playback])

  async function getStyles() {
    if (query.kind) {
      const response = await getEventStyles({
        kind: query.kind
      })
      setStyles(response.data)
    }
  }

  async function getGroup() {
    if (query.kind) {
      const response = await getWebinars({
        kind: query.kind
      })

      if (response.data.length === 0) return
      setWebinars(response.data.groups[0])
    }
  }

  const displayMessage = (
    title: string,
    description: string,
    onTimeout?: () => void
  ) => {
    setMessage({ title, description });
    setShowModal(true);
  };

  const onChange = (attr: string, value: string) => {
    const updatedUserData = new Map(userData);
    updatedUserData.set(attr, value);
    setUserData(updatedUserData);
  };

  
  const onRegister = async (event: any) => {
    event.preventDefault();
    const btnRegister = document.getElementById(
      "btnRegister"
    ) as HTMLButtonElement;
    if (btnRegister) {
      btnRegister.disabled = true;
      btnRegister.value = "Enviando...";
    }

    const email = userData.get("email") || "";

    try {
     
      const response = await subscribeApi.subscribe(email, webinars?.owner_username!, webinars?.slug!, Object.fromEntries(userData.entries()), 'group');

      if (response.status === 200) {
        const userInfos: IStoragedUser = {
          email: email,
          name: userData.get("attendee_name") || (email ? email.split("@")[0] : ""),
          company: userData.get("company") || "",
          talk
        };
        localStorage.setItem(`@NDI-WEBINAR-${webinars?.name}`, JSON.stringify(userInfos));
        history.push(`/${query.kind}/assista`)
        return;
      } else {
        displayMessage(
          t("modal.error.title"),
          t("modal.error.text")
        );
        return;
      }
    } catch (err) {
      console.log("ocorreu um erro", err);
      displayMessage(
        t("modal.error.title"),
        t("modal.error.text")
      );
      btnRegister.disabled = false;
      btnRegister.value = "Inscreva-se";

      return;
    }
  };

  function getDate(date: string) {
    if (!date) return ""
    const dateSplited = date.split("/")
    const day = dateSplited[0]
    const month = dateSplited[1]

    if (isPt) return `${day}/${month}`

    return `${month}/${day}`
  }

  function getDateDescription(date: string) {
    if (!date) return ""

    let parts = date.split(' às ');
    let data = parts[0].split('/');
    let day = data[0];
    let monthNumber = parseInt(data[1], 10);
    let year = data[2];
    let hourMinute = parts[1];

    let monthName = monthsPortugese[monthNumber - 1];
    let monthNameInEnglish = monthsEnglish[monthNumber - 1];

    if (isPt) {
      return `${day} de ${monthName} de ${year} às ${hourMinute}`
    } else {
      return `${monthNameInEnglish} ${day}, ${year}, at ${hourMinute}`
    }
  }

  function getHours(date: string, timezone: string) {
    let parts = date.split(' às ');
    let hourMinute = parts[1];

    if (isPt) {
      return `Às ${hourMinute} ${timezone}`;
    }

    return `At ${hourMinute} ${timezone}`;
  }

  const generateCustomField = (field: CustomField) => {

    const labelLanguage = field[`label_${languageCode}` as keyof CustomField] as string;
    const label = labelLanguage.trim() != "" ? labelLanguage : field.label;

    const placeholderLanguage = field[`placeholder_${languageCode}` as keyof CustomField] as string;
    const placeholder = placeholderLanguage.trim() != "" ? placeholderLanguage : field.placeholder;

    if (field.type === 'number') {
      return (
        <Input
          required={field.required}
          label={label}
          name={field.name}
          type="number"
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'cpf') {
      return (
        <Input
          required={field.required}
          mask="999.999.999-99"
          label={label}
          name={field.name}
          type="tel"
          error={!isValidCpf(userData.get(field.name) ?? "") ? "Insira um CPF válido" : ""}
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'phone') {
      return (
        <Input
          required={field.required}
          mask="(99)99999-9999"
          label={label}
          name={field.name}
          type="tel"
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'email') {
      return (
        <Input
          required={field.required}
          label={label}
          name={field.name}
          error={!isValidEmail(userData.get(field.name) ?? "") ? "Insira um E-mail válido" : ""}
          type="email"
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'cnpj') {
      return (
        <Input
          required={field.required}
          mask="99.999.999/9999-99"
          label={label}
          name={field.name}
          type="tel"
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'cep') {
      return (
        <Input
          required={field.required}
          mask="99999-999"
          label={label}
          name={field.name}
          type="tel"
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'date') {
      return (
        <Input
          required={field.required}
          mask="99/99/9999"
          label={label}
          name={field.name}
          type="text"
          error={!isValidDate(userData.get(field.name) ?? "") ? "Insira uma data válida" : ""}
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'password') {
      return (
        <Input
          required={field.required}
          label={label}
          name={field.name}
          type="password"
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          key={field.name}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
    else if (field.type === 'select') {
      let optionsParse = label.split(';');

      let jsonOptions = optionsParse.reduce((options: any, opt: any) => {
        let option = null;

        try {
          option = JSON.parse(opt);
          option.label = option.label.trim();
          option.value = option.value.trim();
        } catch (err) {
          console.warn('generateSelect got an JSON.parse issue');
        }

        if (option) {
          options.push(option);
        }

        return options;
      }, []);

      return (
        <Select
          key={field.name}
          name={field.name}
          defaultValue={field.default}
          onChange={(e) => onChange(field.name, e.target.value)}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        >
          {jsonOptions}
        </Select>
      );
    }
    else if (field.type !== 'privacy_policy') {
      return (
        <Input
          required={field.required}
          label={label}
          name={field.name}
          type="text"
          placeholder={placeholder}
          onChange={(e) => onChange(field.name, e.target.value)}
          value={userData.get(field.name) ?? ""}
          disabled={field.dependent && userData.get(field.dependent.field) !== field.name}
        />
      );
    }
  }

  const handleAccept = (e: any) => {
    if(webinars?.form) {
      const customTerm = webinars?.form.fields.find((field: CustomField) => field.type === 'privacy_policy');
      if (customTerm) {
        onChange(customTerm.name, e.target.checked);
      }
    }
    setAcceptTerms(e.target.checked);
  };

  return (
    <>
      {showModal && (
        <Modal
          title={message.title}
          description={message.description}
          onClose={() => setShowModal(false)}
        />
      )}
      <Container 
        backgroundColor={styles?.body?.form.pageBackground} 
        backgroundImage={styles?.images?.banners[0] && styles?.images?.banners[0]?.url}
      >
        <WrapperForm>
          <LeftSide  backgroundColor={styles?.body?.form.bannerBackground} backgroundImage={styles?.images?.banner_bg_image}>
            <Cards >
              {webinars?.talks.map((talk) => (
                <ScheduleCard >
                  <Title letterSpacing={"1px"} color={getContrastColor(styles?.body?.form.bannerBackground || "")}>
                    {talk.title}
                  </Title>
                  <DateRow>
                    <DateTag tagColor={styles?.body?.form.tagColor} style={{ color: getContrastColor(styles?.body?.form.tagColor || "") }}>{getDate(talk.date)}</DateTag>
                    <p style={{ color: getContrastColor(styles?.body?.form.bannerBackground || "") }}>
                      {getHours(talk.date, talk.timezone)}
                    </p>
                  </DateRow>
                </ScheduleCard>
              ))
              }
            </Cards>
          </LeftSide>

          <Form onSubmit={onRegister}>
            <Header>
              <Title color="black">{webinars?.name}</Title>
              <Description>
                <DescriptionText textcolor="black">
                  {webinars?.description}
                </DescriptionText>
                <DescriptionText textcolor={styles?.body?.form.tagColor}>
                  {webinars?.talks && webinars?.talks.length > 0 ? getDateDescription(webinars?.talks[0].date) : ""}
                </DescriptionText>
              </Description>
            </Header>
            <InfoText>
              {t("form.description")}
            </InfoText>
            <FormContent>
              <Input
                  required={true}
                  name="input-email"
                  label="E-mail"
                  type="email"
                  placeholder="Informe o seu e-mail"
                  onChange={(e) => onChange("email", e.target.value ?? "")}
                  value={userData.get("email") ?? ""}
                />
                  {webinars?.form && webinars?.form.fields.map((field: CustomField) => <InputRow key={field.name}>{generateCustomField(field)}</InputRow>)}
                
                <InputRow style={{ justifyContent: "space-between" }}>
                  <select onChange={(e) => {
                    setTalk(e.target.value as string)
                  }}
                    style={{ width: "100%", height: "40px", borderRadius: "4px", border: "1px solid #ccc", padding: "10px" }}
                    value={talk}
                  >
                    {webinars?.talks.map((talk) => (
                      <option value={talk.playback_stream_name}>{talk.title}</option>
                    ))}
                  </select>
                </InputRow>
                <TermsInput
                  color={styles?.body?.form.bannerBackground}
                  onChange={handleAccept}
                  customTerms={webinars?.form && webinars?.form.fields.filter((field: CustomField) => field.type === 'privacy_policy')}
                />
                <Button
                  id="btnRegister"
                  RightIcon={<ArrowRight />}
                  background={styles?.body?.form.bannerBackground}
                  colorfont={getContrastColor(styles?.body?.form.bannerBackground || "")}
                  title={t("form.send")}
                  type="submit"
                  disabled={!acceptTerms}
                />
            </FormContent>
          </Form>
        </WrapperForm>
      </Container>
    </>
  );
}
